
import React, { useState, useEffect } from "react";
import { useTranslations } from 'next-intl';
import { useLocalStorage } from 'hooks/localstorage';
import Display from './display';
import History from './history';

import Image from "next/image";
import Faq from '../faq';
import Rating from '../rating';
import { FullScreen, useFullScreenHandle } from "react-full-screen";
export default function Stopwatch({ lang_code, page_content, embed = false, faq = [] }) {
  const t = useTranslations();
  const fullscreenfn = useFullScreenHandle();
  const default_time = {
    totalTimeMs: 0,
    currentTimeMs: 0,
    currentTimeSec: 0,
    currentTimeMin: 0,
    currentTimeHr: 0,
  };

  const [datetime, setDatetime] = useState(null);
  const [currenttime, setCurrenttime] = useState({ ...default_time });


  const stopwatch_info = [{
    icon: (<Image width="43px" height="43px" src={'/images/icon_intervals.svg'} />
    ),
    text: t('key_stopwatch_info_1')
  }, {
    icon: (<Image width="43px" height="43px" src={'/images/icon_CPU.svg'} />),
    text: t('key_stopwatch_info_2')
  }, {
    icon: (<Image width="43px" height="43px" src={'/images/icon_countdown.svg'} />),
    text: t('key_stopwatch_info_3')
  }
  ];


  useEffect(() => {
    setDatetime(+new Date());
  }, []);



  return (
    <>
      <div className="stopwatch-container">
        <FullScreen handle={fullscreenfn}>
          <div className="display-container my-container">
            <Display t={t} fullscreenfn={fullscreenfn} default_time={default_time} lap_time={currenttime} />
          </div>
          {/*<div className="last-lap-container my-container">
            <Lap t={t} is_last={true} index={5} current_time={currenttime} default_time={default_time} lap_time={currenttime} />
          </div>*/}
          <div className="lap-history my-container">
            {datetime && <History t={t} />}
          </div>
        </FullScreen>
        {!embed && <>
          <div className="my-container info-block m-top-40 ">
            {stopwatch_info.map((v, i) => {
              return (<div key={i} className="info-block-each">
                <div className="info-block-each-icon">{(i + 1)})</div>
                <div className="info-block-each-text">{v.text}</div>
              </div>)
            })}
          </div>
          <div className='my-container m-top-28 page-content-coantainer' dangerouslySetInnerHTML={{ __html: page_content.replace('TimerTone.com', `<a  name="timertone" href="//${lang_code}.timertone.${process.env.NEXT_PUBLIC_DOMAIN_SUFFIX}/dashboard/alarm">TimerTone.com</a>`) }}>

          </div>
          {<Faq faq={faq} from={'stopwatch'} lang_code={lang_code} />}

        </>}
      </div>
    </>

  )

}


